import styled from 'styled-components';

export const SpinnerWrapper = styled.div`
	text-align: center;
`;
